import { useEffect } from 'react';
import useStores from '$src/hooks/useStores';

function useCustomSettings(userId, locationId) {
  const {
    devicesStore: { fetchDevices },
    preferencesStore: { fetchPreferences },
  } = useStores();

  useEffect(() => {
    fetchDevices(locationId, userId);
    fetchPreferences(userId, locationId);
  }, [userId, locationId, fetchDevices, fetchPreferences]);
}

export default useCustomSettings;
